import type { CloseContent } from './typings'

export const closeContentActionCreator = (): CloseContent => ({
  type: 'activities/closeContent',
})
